export class UserValidationStatusRespose {
    Status: string;
    Error: string;
    UserName: string;
    Email: string;
    IsChangeEmailPassword: boolean;
    ClientsData: AuthorizedClient; 
    IDUser: string;
    NoIntervenant : string;
    LbSta : string;
    Token : string;
}

export class AuthorizedClient
{
    PropertyChanges : string;
    toDelete : string;
    CodePostal : string;
    Email : string;
    LibellePays : string;
    Localite : string;
    NoClient : string;
    NoRue : string;
    Nom : string;
    NumeroBCE : string;
    Prenom : string;
    QualCiv : string;
    RegimeLinguistique:number;
    Rue : string
}

export class GetUserResult
{
    IdUsr :string;
    LbSta : string;
    TlAdrEmlUsr : string;
    FlChgPsw: boolean;
    NmcteUsrMap: string;
    NmCteUsr: string;
    FlgEncData
    Languagecode : string;
    TlPsw : string;
    firstName : string;
    lastName : string;
    Nmsoc: object;
}

export class UserResetPasswordResponse
{
    IntState : string;
    TlPsw : string;
    Username : string;
    TimeStamp : string;
    Languagecode:string;
}

export class XdecryptRequest{
    str: string;
}

export class UserResetmail
{
    To : string;
    ContentType : string;
    Subject : string ;
    Language : string; 
    Body : string;
}
 
export class UserValidationChild{
    
    UserName : string;
    Password : string;
}